import { Epic, ofType } from 'redux-observable';
import { of, merge } from 'rxjs';
import { switchMap, catchError } from 'rxjs/operators';
import { actions as authActions } from '@ui/store/auth';
import { EpicDependencies } from '@ui/store/rootEpic';
import { getUserToken } from '@ui/tools/token';
import { User } from '@ui/types';
import * as actions from '../actions';

export const loadingInitialApp: Epic<any, any, any, EpicDependencies> = (
  action$,
  store,
  { authApi },
) =>
  action$.pipe(
    ofType(actions.MAIN_ACTIONS.REQUESTED),
    switchMap(() => {
      const token = getUserToken();
      return authApi.checkLoggedIn(token).pipe(
        switchMap((user: User) => {
          if (user) {
            return merge(
              of(authActions.authReloaded(user)),
              of(actions.mainSucceeded()),
            );
          }
          return of(actions.mainSucceeded());
        }),
        catchError(error => {
          console.log(error);
          return of(actions.mainFailed(error.message as string));
        }),
      );
    }),
  );

export default loadingInitialApp;



// WEBPACK FOOTER //
// ./src/Main/services/epics/loadInitialApp.ts